import { render } from "./RevolutionFundChart.vue?vue&type=template&id=24195f74"
import script from "./RevolutionFundChart.vue?vue&type=script&lang=js"
export * from "./RevolutionFundChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__